import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import $ from "jquery";
import Settings from "./Settings";
import Configuration from "./Configuration";
import Leads from "./Leads";
import AdvanceSettings from "./AdvanceSettings";
import ManageTemplate from "./ManageTemplate";
import LeadsSettings from "./LeadsSettings";

class TeamSettings extends Component {
  constructor() {
    super();
    this.state = {
      projectId: null,
      hideBotStore: false,
      showOnlyMyLeads: false,
    };
  }
  componentDidMount() {
    var userRole = localStorage.getItem("PROJECT_ROLE");
    if (userRole === "PROJECT_SUPPORT_USER") {
      this.setState({ showOnlyMyLeads: true });
    }

    (function () {
      var currentPath = window.location.href;
      var currentPath = window.location.href;
      var path = window.origin + "/sales-desk/projectmgmt/settings";
      var path1 = window.origin + "/sales-desk/projectmgmt/settings/";
      if (currentPath === path || currentPath === path1) {
        $("#lead-mapping").addClass("active");
      } else if (currentPath.includes("/projectmgmt/settings/configuration")) {
        $("#configuration").addClass("active");
      } else if (currentPath.includes("/projectmgmt/settings/leads")) {
        $("#leads").addClass("active");
      } else if (
        currentPath.includes("/projectmgmt/settings/advanceSettings")
      ) {
        $("#advanceSettings").addClass("active");
        console.log("Inside #advanceSettings Team Settings");
      } else if (
        currentPath.includes("/projectmgmt/settings/manage-template")
      ) {
        $("#manage-template").addClass("active");
      } else {
        $("#" + localStorage.getItem("last-team-data-tab")).addClass("active");
      }
      $(
        "#lead-mapping,#configuration,#leads,#advanceSettings,#manage-template"
      ).on("click", function () {
        $(
          "#lead-mapping,#configuration,#leads,#advanceSettings,#manage-template"
        ).removeClass("active");
        localStorage.setItem("last-team-data-tab", $(this)[0].id);
        $(this).addClass("active");
      });
    })();
  }

  render() {
    return (
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Settings</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/settings"
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className="nav-link"
                    id="lead-mapping"
                    style={{
                      marginRight: "15px",
                      display: this.state.showOnlyMyLeads ? "none" : "block",
                    }}
                  >
                    Team
                  </li>
                </Link>
                <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/settings/configuration"
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className="nav-link"
                    id="configuration"
                    style={{
                      marginRight: "15px",
                      display: this.state.showOnlyMyLeads ? "none" : "block",
                    }}
                  >
                    Configuration
                  </li>
                </Link>
                <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/settings/leads"
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className="nav-link"
                    id="leads"
                    style={{ marginRight: "15px" }}
                  >
                    Leads
                  </li>
                </Link>
                <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/settings/advanceSettings"
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className="nav-link"
                    id="advanceSettings"
                    style={{
                      marginRight: "15px",
                      display: this.state.showOnlyMyLeads ? "none" : "block",
                    }}
                  >
                    Advanced Settings
                  </li>
                </Link>

                <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/settings/manage-template"
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className="nav-link"
                    id="manage-template"
                    style={{
                      marginRight: "15px",
                      display: this.state.showOnlyMyLeads ? "none" : "block",
                    }}
                  >
                    Manage Whatsapp Template
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path="/projectmgmt/settings"
            component={Settings}
          ></Route>
          <Route
            path="/projectmgmt/settings/configuration"
            component={Configuration}
          ></Route>
          <Route
            path="/projectmgmt/settings/leads"
            component={LeadsSettings}
          ></Route>
          <Route
            path="/projectmgmt/settings/advanceSettings"
            component={AdvanceSettings}
          ></Route>
          <Route
            path="/projectmgmt/settings/manage-template"
            component={ManageTemplate}
          ></Route>
        </Switch>
      </div>
    );
  }
}
export default TeamSettings;



// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/TeamSetting.js